import IDokument from "../ts/IDokument";
import URLEndPointBE from "./URLEndPointBE";

//id=1, function(upd/del, id) ... props.dokumentId
interface IDisplayDokument{
    dokumentId:number|null
}
function DisplayDokument(props: IDisplayDokument) {
    console.log("displaying dokument")
    const dokumentEndpoint = URLEndPointBE+`/dokument`
    {/*if logged display delete*/}
    {/* span onClick={()=>onDel(id)} */}
    {/*&nbsp;<span className="katBtnStyle">&#9249;</span>*/}

    return(
        <span className={"documentUploadStyle"}>
            <b>DOKUMENT</b>&nbsp;<span className={"docName"}>D022-D-{props.dokumentId}.pdf</span>
            &nbsp;<a href={dokumentEndpoint+"/"+props.dokumentId} target="_blank" className="navRemoveUnderscoreInLinkA"><span className="katBtnStyle">&#x1F50E;&#xFE0E;</span></a>
        </span>
    )
    /*
    Dokument simplePrev 
    Dokument mod/ex w/X
    Dokument mod/upl w/X
    */
}
export default DisplayDokument